import { render } from "./Recepcion.vue?vue&type=template&id=de420af6&scoped=true"
import script from "./Recepcion.vue?vue&type=script&lang=js"
export * from "./Recepcion.vue?vue&type=script&lang=js"

import "./Recepcion.vue?vue&type=style&index=0&id=de420af6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de420af6"]])

export default __exports__